exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3kHy {\n    font-size: 16px;\n    border: none;\n    background-color: white;\n    padding: 10px 20px 10px 0;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n.pCTW {\n    fill: #9e9e9e;\n}\n\n._38jJ {\n    margin-left: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"button": "_3kHy",
	"arrow": "pCTW",
	"text": "_38jJ"
};